import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import "./PrincipalActuariesList.css"; 

const actuaries = [
  {
    id: "01",
    name: "Daniel Aidoo Mensah",
    credentials: "FASG, AIA",
    company: "Aidoo Mensah & Associates",
    expiry: "April 2027",
    image: "daniel-aidoo-mensah.jpg",
  },
  {
    id: "02",
    name: "Kojo Essel-Mensah",
    credentials: "FASG, FIA",
    company: "BerryBright Consulting",
    expiry: "February 2025",
    image: "kojo-essel-mensah.jpg",
  },
  {
    id: "03",
    name: "Ritin Chauhan",
    credentials: "FASG, FIA, FASSA",
    company: "QED Actuaries & Consultants",
    expiry: "April 2027",
    image: "ritin-chauhan.jpg",
  },
  {
    id: "04",
    name: "Tarryn Fahy",
    credentials: "FASG, FASSA",
    company: "QED Actuaries & Consultants",
    expiry: "April 2027",
    image: "tarryn-fahy.jpg",
  },
  {
    id: "05",
    name: "Christine van Heerden",
    credentials: "FASG, FASSA",
    company: "QED Actuaries & Consultants",
    expiry: "April 2027",
    image: "christine-van-heerden.jpg",
  },
  {
    id: "06",
    name: "Giles Waugh",
    credentials: "FASG, FIA, FASSA",
    company: "Deloitte Ghana",
    expiry: "December 2025",
    image: "giles-waugh.jpg",
  },
  {
    id: "07",
    name: "Redouan Hmami",
    credentials: "AASG, IA (France)",
    company: "Deloitte Ghana",
    expiry: "December 2025",
    image: "redouan-hmami.jpg",
  },
  {
    id: "08",
    name: "Clair Megan Gavin",
    credentials: "FASG, FASSA",
    company: "Deloitte Ghana",
    expiry: "December 2025",
    image: "clair-megan-gavin.jpg",
  },
  {
    id: "09",
    name: "Takalani Sikhavhakhava",
    credentials: "FASG, FASSA",
    company: "Deloitte Ghana",
    expiry: "December 2025",
    image: "takalani-sikhavhakhava.jpg",
  },
  {
    id: "10",
    name: "Katlego Thaba",
    credentials: "FASG, FASSA",
    company: "Deloitte Ghana",
    expiry: "December 2025",
    image: "takalani-sikhavhakhava.jpg",
  },
  {
    id: "11",
    name: "Isaac Senior Damptey",
    credentials: "FASG, ASA, FCA, ACIA",
    company: "United Actuaries & Consultants",
    expiry: "May 2027",
    image: "takalani-sikhavhakhava.jpg",
  },
    {
    id: "12",
    name: "Charles Osei-Akoto",
    credentials: "",
    company: "Stallion Consultants Limited",
    expiry: "June 2027",
    image: "takalani-sikhavhakhava.jpg",
  },
    {
    id: "13",
    name: "Damon Vaughn Munday",
    credentials: "",
    company: "Sanlam Allianz Gen.eral Insurance (GH) Ltd",
    expiry: "June 2027",
    image: "takalani-sikhavhakhava.jpg",
  },
    {
    id: "14",
    name: "Ortopah Kojo Botchey",
    credentials: "FASG, SAA, AIA, PhD",
    company: "Orbotrice Institute",
    expiry: "August 2027",
    image: "takalani-sikhavhakhava.jpg",
  },
    {
    id: "15",
    name: "Michael Kwaku Ankrah",
    credentials: "AASG, ASA",
    company: "United Actuaries & Consultants",
    expiry: "May 2027",
    image: "takalani-sikhavhakhava.jpg",
  },
];

  const handleDownloadASP = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to download the ASP Application Form.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, download it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const link = document.createElement("a");
        link.href = "/files/ASP_License_Form-v2.pdf"; 
        link.download = "ASP_License_Form-v2.pdf"; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };
  
  const handleDownloadNIC = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to download the NIC Directive.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, download it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const link = document.createElement("a");
        link.href = "/files/NIC_CIRCULAR_APPROVAL OF ACTUARY.pdf"; 
        link.download = "NIC_CIRCULAR_APPROVAL OF ACTUARY.pdf"; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };
  
// Function to convert expiry text to a Date object
const parseExpiryDate = (expiryText) => {
    const months = {
      January: 0, February: 1, March: 2, April: 3, May: 4, June: 5,
      July: 6, August: 7, September: 8, October: 9, November: 10, December: 11
    };
  
    const [month, year] = expiryText.split(" ");
    return new Date(parseInt(year), months[month], 1);
  };
  
  const PrincipalActuariesList = () => {
    const currentDate = new Date();
  
    return (
        <div className="principal-actuaries">
        <section className="section-aboutasg" >
          <div className="sectiontop-line"></div>
          <h2 className="sectiontitle">PRINCIPAL ACTUARY</h2>
          <div className="sectionbottom-line"></div>
        </section>
        <div className="main-container">
        <section className="university-section">
        <div className="actuaries-list">
          {actuaries.map((actuary) => {
            const expiryDate = parseExpiryDate(actuary.expiry);
            const isExpired = expiryDate < currentDate;
  
            return (
              <div className="actuary-card" key={actuary.id}>
                <div className="ID">{actuary.id}</div>
                <div className="actuary-image">
                  <img
                    src={`/images/actuaries/${actuary.image}`}
                    onError={(e) => (e.target.src = "/images/default-profile.png")}
                    alt={actuary.name}
                  />
                </div>
                <div className="actuary-details">
                  <h3>{actuary.name} <span className="credentials">{actuary.credentials}</span></h3>
                  <p className="company">{actuary.company}</p>
                  <p className={`expiry ${isExpired ? "expired" : "valid"}`}>
                    <strong>EXPIRY:</strong> {actuary.expiry}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        </section>
        <section className="card-section" style={{ marginTop: "10px" }}>
            <div className="accreditation-card" onClick={handleDownloadASP} style={{ cursor: "pointer" }}>
                <h2 className="uni-title">ASP Application Form</h2>
            </div>
            <div className="accreditation-card" onClick={handleDownloadNIC} style={{ cursor: "pointer" }}>
                <h2 className="uni-title">NIC Directive</h2>
            </div>
          <Link to="/pas-licenses">
            <div className="accreditation-card">
              <h2 className="uni-title">PAS-Licenses</h2>
            </div>
          </Link>
        </section>
        </div>
      </div>
    );
  };
  
  export default PrincipalActuariesList;
